import { defineStore } from 'pinia'

const usePageSize = defineStore('pagesize', {
	state: () => ({
		width: document.documentElement.clientWidth,
		height: document.documentElement.clientHeight,
	}),
	getters: {
		
	},
	actions: {
		resetPage(w, h) {
			this.width = w
			this.height = h
		}
	}
})

export default usePageSize